export const WEIGHT_STEP = 5;
export const MIN_WEIGHT = 5;
export const MAX_WEIGHT = 100;
export const REQUIRED_TOTAL = 100;

export const WEIGHT_SIGNALS = [
	{
		key: 'engagement_cadence',
		title: 'Engagement cadence',
		description:
			"How consistently engagement with the account occurs relative to its Coverage Tier's expected cadence.",
		defaultWeight: 40,
	},
	{
		key: 'historical_pattern',
		title: 'Historical pattern',
		description:
			"The account's track record of prior commitments influenced by sizing trend and recency.",
		defaultWeight: 35,
	},
	{
		key: 'process_momentum',
		title: 'Process momentum',
		description:
			'Whether open fundraising opportunity stage movement is on pace, slipping, or stalled against benchmark in related entity.',
		defaultWeight: 25,
	},
];

export const DEFAULT_WEIGHTS = WEIGHT_SIGNALS.reduce(
	(weights, { key, defaultWeight }) => ({ ...weights, [key]: defaultWeight }),
	{}
);

export const WEIGHTING_DISCLAIMER =
	'Changes will apply starting with the next Relationship Health Score calculation. Health Scores currently displayed across LP360 pages will not be recalculated retroactively.';

export const WEIGHTING_ALERTS_DISCLAIMER =
	'Health Score Alerts will not be triggered overnight as a result of these weighting adjustments. This prevents a large number of alerts from being created at once, which would add noise rather than signal.';

export const normalizeWeights = (weights) =>
	WEIGHT_SIGNALS.reduce(
		(normalized, { key, defaultWeight }) => ({
			...normalized,
			[key]: Number.isFinite(weights?.[key]) ? weights[key] : defaultWeight,
		}),
		{}
	);

export const sumWeights = (weights) =>
	WEIGHT_SIGNALS.reduce((total, { key }) => total + (weights?.[key] ?? 0), 0);
